import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {SignUpService} from "../../service/sign-up.service";
import {RegistrationBaseComponent} from "../registration-base-component/registration-base-component";
import {RegistrationApiService} from "../../api/registration-api.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {SignatureDto} from "../../../cross/user-signatures/type/user-signatures.types";
import {AppMessageService} from "../../../core/service/app-message.service";
import {FormControl} from "@angular/forms";


@Component({
  selector: 'registration-affirmations',
  templateUrl: './registration-signatures.component.html',
  styleUrl: './registration-signatures.component.scss'
})
export class RegistrationSignaturesComponent extends RegistrationBaseComponent {

  signaturesComplete: boolean = false;
  signatures?: SignatureDto[];

  constructor(protected override registrationApiService: RegistrationApiService,
              protected override signUpService: SignUpService,
              protected override coreApiService: CoreApiService,
              protected messageService: AppMessageService) {
    super(registrationApiService, signUpService, coreApiService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  override initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  override refreshComponent() {

    this.signatures = this.signUpService.signatures;

    this.checkSignaturesComplete();

    this.initialized = true;

  }

  handleSignatureChanges(signatures: SignatureDto[]) {
    // check whether all documents where provided
    this.signatures = signatures;
    this.checkSignaturesComplete();

  }

  updateSignatures() {

    this.formGroup.addControl('signatures', new FormControl(''));
    this.formGroup.patchValue({
      signatures: this.signatures
    });
    this.updateRegistration();
  }

  checkSignaturesComplete(): boolean {

    let signaturesComplete = true;

    if (this.signatures) {
      for (let signature of this.signatures) {
        if (!signature.signatureSwitch && !signature.signatureBase64) {
          signaturesComplete = false;
        }
      }
    }

    this.signaturesComplete = signaturesComplete;

    return signaturesComplete;

  }

  /*
    finalizeRegistration() {

      const dto: RegistrationRequestOtpDto & RegistrationDto &  {[key: string]: any} = {};

      dto.phoneNumber = this.signUpService.phoneNumber;
      dto.registrationGuid = this.signUpService.registrationGuid;
      dto.deviceInfo = this.coreApiService.getDeviceInfo();

      dto.documents = this.documents;

      this.registrationApiService.update(dto).subscribe(res => {

        alert("finished!");

        //navigate to ob/start

      }, error => {
        if (error?.data) {
          this.messageService.showErrorMessage("", error.data);
        } else {
          this.messageService.showErrorMessage("", "Es ist ein Fehler aufgetreten.");
        }

      });

    }
  */
  override postObjectRefresh() {
    this.navigateNextStep(4);
  }


}
